import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import useTranslation from "hooks/Translation";

// Register required components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

function LineAreaChart({
  keys,
  values,
  label,
  backgroundColor,
  borderColor,
  pointBackgroundColor,
}) {
  const t = useTranslation();

  // Chart Data
  const data = {
    labels: keys,
    datasets: [
      {
        label: label,
        data: values,
        fill: true, // Fill the area under the line
        backgroundColor: backgroundColor
          ? backgroundColor
          : "rgba(173, 216, 230, 0.2)", // Light transparent fill
        borderColor: borderColor ? borderColor : "rgba(173, 216, 230, 1)", // Line color
        pointBackgroundColor: pointBackgroundColor
          ? pointBackgroundColor
          : "rgba(173, 216, 230, 1)",
        borderWidth: 2,
        tension: 0.4, // Smooth line
      },
    ],
  };

  // Chart Options
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          color: "#333", // Legend text color
          font: { size: 14 },
        },
      },
      tooltip: {
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        titleColor: "#fff",
        bodyColor: "#fff",
        titleFont: { size: 14 },
        bodyFont: { size: 12 },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#666", // X-axis labels
        },
      },
      y: {
        grid: {
          color: "rgba(211, 211, 211 ,0.2)",
        },
        ticks: {
          color: "#666", // Y-axis labels
        },
      },
    },
  };

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox padding="1rem">
        <MDBox pb={5}>
          <MDTypography variant="h6" textTransform="capitalize">
            {`${label} ${t.main.overView}`}
          </MDTypography>
        </MDBox>
        <MDBox
          // variant="gradient"
          borderRadius="lg"
          py={2}
          pr={0.5}
          mt={-5}
          height="20rem"
        >
          <Line data={data} options={options} />
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default LineAreaChart;
